import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { telegramOidcCallback } from '../api/auth';
import { useAuth } from '../auth/AuthContext';
import { apiErrorCode, authErrorMessage } from '../auth/errors';
import { TELEGRAM_OIDC_FLOW_KEY } from '../auth/telegramOidc';

export function TelegramCallbackPage() {
  const { t } = useTranslation(['auth', 'common', 'errors']);
  const { applyUser } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);
  const [conflict, setConflict] = useState(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const params = new URLSearchParams(window.location.search);
    window.history.replaceState(null, '', window.location.pathname);
    const code = params.get('code');
    const state = params.get('state');
    let flow: { binding: string; purpose: 'login' | 'link' } | null = null;
    try {
      flow = JSON.parse(sessionStorage.getItem(TELEGRAM_OIDC_FLOW_KEY) || 'null');
    } catch {
      flow = null;
    }
    sessionStorage.removeItem(TELEGRAM_OIDC_FLOW_KEY);
    if (params.get('error')) {
      setError(t('auth:telegramCancelled'));
      return;
    }
    if (!code || !state || !flow) {
      setError(t('auth:errors.invalid_state'));
      return;
    }
    const purpose = flow.purpose;
    void telegramOidcCallback({ code, state, binding: flow.binding })
      .then((res) => {
        if (res.session) {
          applyUser(res.session.user);
          navigate('/', { replace: true });
        } else if (res.user) {
          applyUser(res.user);
          navigate('/security', { replace: true, state: { notice: 'telegramLinked' } });
        }
      })
      .catch((err) => {
        setConflict(purpose === 'login' && apiErrorCode(err) === 'telegram_already_linked');
        setError(authErrorMessage(t, err));
      });
  }, [applyUser, navigate, t]);

  return (
    <div className="page auth-page auth-sheet-page">
      <article className="auth-card auth-sheet">
        <h1>Telegram</h1>
        {error ? (
          <>
            <p className="auth-error" role="alert">
              {error}
            </p>
            <Link to="/auth/login" className="btn btn-primary btn-block">
              {conflict ? t('auth:signInToLink') : t('auth:backToLogin')}
            </Link>
          </>
        ) : (
          <p className="muted-note" role="status">
            {t('auth:telegramWorking')}
          </p>
        )}
      </article>
    </div>
  );
}
